export default "__VITE_ASSET__BlFRp030__";